<template>
  <div class="root">
    <div class="searchDiv">
      <div class="searchmodel">
        <el-input
          v-model="keyword"
          @keyup.enter.native="getList('')"
          placeholder="请输入关键字搜索"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getList('')"
          ></i>
        </el-input>
      </div>
    </div>
    <ul class="ul_left">
      <li
        v-for="(item, index) in li_bg"
        :key="index"
        @click="changeBg(index, item.number)"
      >
        <div
          v-show="index == idx"
          class="image"
          :style="{
            'background-color': '#2187FF',
          }"
        >
          <!-- <div
          v-show="index == idx"
          class="image"
          :style="{
            'background-color':
              cityDetail.cityName == '华龙区' ? '#6680ea' : '#2187FF',
          }"
        > -->
          <div style="text-align: center; flex: 1">
            <span style="color: #fff">{{ item.classname }}</span>
          </div>
          <img :src="item.activeImg" alt />
        </div>
        <!-- <div
          v-show="index != idx"
          class="image"
          :style="{
            color: cityDetail.cityName == '华龙区' ? '#6680ea' : '#2187FF',
          }"
          style="background-color: #fff; border: 1px solid #ddd"
        > -->
        <div
          v-show="index != idx"
          class="image"
          :style="{
            color: '#2187FF',
          }"
          style="background-color: #fff; border: 1px solid #ddd"
        >
          <div style="text-align: center; flex: 1">
            <span>{{ item.classname }}</span>
          </div>
          <img :src="item.lazyImg" alt />
        </div>
      </li>
    </ul>
    <ul class="ul_right">
      <li class="li_right" v-for="(item, index) in titles" :key="index">
        <router-link :to="{ name: '交易指南详情', query: { id: item.id } }">{{
          item.title
        }}</router-link>
        <p>
          <span style>{{ item.logintime }}</span>
          <span>来源：{{ item.source }}</span>
        </p>
      </li>
    </ul>

    <div v-if="titles.length > 0">
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <h3 v-else style="font-size: 24px">暂无数据</h3>
  </div>
</template>

<script>
import { getNewslist, getNewsClass } from '../api/mian'
import { cityDetail } from '../util/mainOption'
export default {
  data () {
    return {
      idx: 0,
      li_bg: [],
      titles: [],
      //   每页数据条数
      pageSize: 10,
      // 页数
      currentpage: 1,
      inputpage: 1,
      // 总条数
      total: 0,
      listType: '',
      keyword: '',
    }
  },
  created () { },
  mounted () {
    let data = {
      upnumber: '003',
      pageNum: 1,
      pageSize: 999

    }
    getNewsClass(data).then((res) => {
      // if (this.cityDetail.cityName == '华龙区') {
      //   this.li_bg = res.data.data.map((item) => {
      //     return {
      //       ...item,
      //       lazyImg: require('../assets/HLQimg/' + item.classname + '0.png'),
      //     }
      //   })
      // } else {
      this.li_bg = res.data.data
      // }
      this.getList(this.li_bg[0] ? this.li_bg[0].number : 0)
      this.listType = this.li_bg[0] ? this.li_bg[0].number : 0
    })
  },
  computed: {},
  watch: {},
  methods: {
    changeBg (i, num) {
      this.idx = i
      this.getList(num)
      this.currentpage = 1
      this.listType = num
    },
    async getList (num = '') {
      this.listType = num || this.listType
      let data = {
        number: this.listType,
        pageSize: this.pageSize,
        pageNum: this.currentpage,
        keyword: this.keyword,
        searchValue: this.keyword,
        deptId: cityDetail.deptId
      }
      await getNewslist(data).then((res) => {
        console.log('新闻列表', res)
        this.total = res.data.total
        this.titles = res.data.rows
      })
    },
    // 当前每夜多少条
    handleSizeChange (size) {
      this.pageSize = size
    },
    // 当前页数
    handleCurrentChange (currentpage) {
      this.currentpage = currentpage
      console.log(this.currentpage)
      this.getList(this.listType)
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 35px;
  width: 1860px;
  max-height: 1393px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  opacity: 1;
  overflow: hidden;
}

.ul_left {
  display: block;
  width: 260px;
  height: auto;
  float: left;
  /* background-color: rebeccapurple; */
  padding: 40px 40px;
  list-style: inside none;
}

.ul_left > li {
  display: block;
  width: 260px;
  height: 92px;
  /* background-color: red; */
  margin-bottom: 20px;
  cursor: pointer;
}
.image {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  padding-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.ul_right {
  display: block;
  width: 1300px;
  max-height: 1230px;
  overflow: hidden;
  list-style: inside none;
  margin-bottom: 40px;
}

.ul_right .li_right {
  display: block;
  width: 1300px;
  height: 122px;
  border-bottom: 1px dotted #bebebe;
}

.li_right > a {
  display: block;
  padding: 37px 0 19px 0;
  max-width: 1200px;
  height: 26px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.li_right > p {
  display: block;
  width: auto;

  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #999999;
}

.li_right > p > span {
  display: inline-block;
  width: 250px;
}

.el-pagination {
  text-align: center;
}
.searchmodel /deep/.el-input {
  font-size: 22px;
  /* border: 1px solid red; */
  text-align: left;
}

.searchmodel /deep/.el-input__inner {
  height: 50px;
  width: 300px;
  border: 1px solid #747474;
  border-radius: 10px;
  /* font-size: 16px; */
}

.searchmodel {
  /* margin-left: 500px; */
  width: 300px;
  padding: 0 30px;
  margin-top: 10px;
}
</style>
